module.exports = __webpack_public_path__ + "static/img/defaultImge2058ef.png";